import { PMS_URL } from "utils/constants";

const buildFinderUrl = (endpoint, path, newfinder, subtype) => {
    const subtypeParam = subtype ? `&subtype=${encodeURIComponent(subtype)}` : "";
    return `${PMS_URL}/${endpoint}?vehicle_type=${path}&newfinder=${newfinder ? "true" : "false"}${subtypeParam}`;
};

// Year, Make, Model
export const getYMM = (path, newfinder, subtype) => fetch(
    buildFinderUrl("vehicle_details", path, newfinder, subtype),
    {
        headers: { "Content-Type": "application/json" },
        mode: "cors",
        method: "GET",
    },
).then((data) => data.json());

// get ymm all
export const getYMMAll = (path, newfinder, subtype) => fetch(
    buildFinderUrl("vehicle_details/fetch_finder_data", path, newfinder, subtype),
    {
        headers: { "Content-Type": "application/json" },
        mode: "cors",
        method: "GET",
    },
).then((data) => data.json());

export default getYMM;
